import React, { useState } from "react";
import styled from "styled-components";
// import logo from "assets/logo.png";
import logo from "assets/oakmont/oakmont_no.png";
import { GiHamburgerMenu } from "react-icons/gi";
import { MdClose } from "react-icons/md";
import { useScroll } from "components/useScroll";
import { motion } from "framer-motion";
import { navAnimation } from "animation";
import { yellow } from "./color";
import home from "assets/oakmont/Picture1.jpg";

function Navbar() {
  const [isNavOpen, setIsNavOpen] = useState(false);
  const [element, controls] = useScroll();
  return (
    <Nav
      ref={element}
      variants={navAnimation}
      transition={{ delay: 0.1 }}
      animate={controls}
      state={isNavOpen ? 1 : 0}
    >
      <div className="brand__container">
        <a href="#" className="brand">
          <img src={logo} alt="logo" className="photobrand" />
        </a>

        <div className="toggle">
          {isNavOpen ? (
            <MdClose onClick={() => setIsNavOpen(false)} />
          ) : (
            <GiHamburgerMenu
              onClick={(e) => {
                e.stopPropagation();
                setIsNavOpen(true);
              }}
            />
          )}
        </div>
      </div>
      <div className={`links ${isNavOpen ? "show" : ""}`}>
        <ul>
          <li className="active">
            <a href="#home">Home</a>
          </li>
          <li>
            <a href="#about">About</a>
          </li>
          <li>
            <a href="#case">Case Study</a>
          </li>
          <li>
            <a href="#project">Project</a>
          </li>

          <li>
            <a href="#contactknife">Contact</a>
          </li>
          <li>
            <a
              href="/policy.pdf"
              target="_blank"
              rel="noopener noreferrer"
              style={{ textDecoration: "none", color: yellow }}
            >
              Privacy Policy
            </a>
          </li>
        </ul>
      </div>
    </Nav>
  );
}

const Nav = styled(motion.nav)`
  display: flex;
  height: 80px;
  justify-content: space-between;
  margin: 0rem;
  background: rgb(0, 0, 0, 0.3);
  color: #fff;
  padding-top: 2rem;
  padding-bottom: 1rem;
  padding-right: 2rem;
  padding-left: 2rem;

  &::before {
    content: "";
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background: rgba(255, 255, 255, 0.3); /* Semi-transparent white */
    backdrop-filter: blur(10px); /* Adjust blur intensity */
    z-index: -1;
  }
  .brand__container {
    margin: 0 2rem;
    .photobrand {
      width: 12rem;
    }
    .toggle {
      display: none;
    }
  }
  .links {
    ul {
      list-style-type: none;
      display: flex;
      gap: 3rem;
      color: ${yellow};
      .active {
        a {
          border-bottom: 0.2rem solid var(--secondary-color);
        }
      }
      li {
        a {
          color: ${yellow};
          text-decoration: none;
          font-weight: 400;
          font-size: 0.9rem;
          text-transform: uppercase;
        }
      }
    }
  }
  @media screen and (min-width: 280px) and (max-width: 1080px) {
    margin: 0;
    position: relative;
    padding-left: 0rem;
    padding-right: 0rem;
    padding-top: 1rem;
    .brand__container {
      display: flex;
      justify-content: space-between;
      align-items: center;
      width: 100%;
      .photobrand {
        width: 8rem;
      }
      .toggle {
        padding-right: 1rem;
        display: block;
        z-index: 1;
      }
    }
    .show {
      opacity: 1 !important;
      visibility: visible !important;
      height: 100vh;
    }
    .links {
      position: absolute;
      overflow-x: hidden;
      top: 0;
      right: 0;
      width: ${({ state }) => (state ? "100%" : "0%")};
      height: 100vh;
      background-color: var(--secondary-color);
      opacity: 0;
      visibility: hidden;
      transition: 0.4s ease-in-out;
      ul {
        flex-direction: column;
        text-align: center;
        height: 100%;
        justify-content: center;
      }
    }
  }
`;

export default Navbar;
